"use client";

import { SearchBar } from "@/components/search-bar";
import { Skeleton } from "@/components/skeleton";
import { Container } from "@/components/container";
import {
  CategoriesSelector,
  type CategoriesSelectorProps,
} from "@/components/categories-selector";
import { type OrderOptionValue } from "@/app/(store)/_components/order-dropdown/order-options";
import { FiltersClear } from "@/app/(store)/_components/filters/filters-clear";

import dynamic from "next/dynamic";

const OrderDropdown = dynamic(
  () =>
    import("@/app/(store)/_components/order-dropdown").then(
      (mod) => mod.OrderDropdown
    ),
  { ssr: false }
);

const CategoriesDropdown = dynamic(
  () =>
    import("@/app/(store)/_components/categories-dropdown").then(
      (mod) => mod.CategoriesDropdown
    ),
  { ssr: false }
);

type FiltersProps = {
  categories: {
    list: CategoriesSelectorProps["categories"];
    selected: CategoriesSelectorProps["selected"];
  };
  order?: OrderOptionValue;
};

const FiltersLoading = () => {
  return (
    <div className="mb-7 flex flex-col gap-3 py-4 md:flex-row md:items-center md:justify-between">
      <div className="order-2 flex gap-2 md:order-1">
        <Skeleton width="w-17" height="h-9" />

        <Skeleton width="w-26" height="h-9" />

        <Skeleton width="w-19" height="h-9" />
      </div>

      <div className="order-1 w-full md:order-2 md:w-72">
        <Skeleton height="h-10" />
      </div>
    </div>
  );
};

const Filters = ({ categories, order }: FiltersProps) => {
  return (
    <div className="sticky top-0 z-10 bg-white">
      <Container className="flex flex-col gap-3 py-4">
        <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <div className="order-1 w-full md:order-2 md:flex md:w-auto md:gap-2">
            <div className="hidden md:block">
              <FiltersClear />
            </div>

            <div className="hidden md:block md:w-72">
              <SearchBar />
            </div>
            <div className="block md:hidden md:w-72">
              <SearchBar size="large" />
            </div>
          </div>

          <div className="order-2 flex gap-2 md:order-1">
            <div>
              <OrderDropdown order={order} />
            </div>

            <div className="hidden md:block">
              <CategoriesDropdown
                categories={categories.list}
                selected={categories.selected}
              />
            </div>

            <div className="flex min-w-0 md:hidden">
              <CategoriesSelector
                categories={categories.list}
                selected={categories.selected}
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export { Filters, FiltersLoading, type FiltersProps };
